export enum AboDetailValueType {
  String,
  Date
}
